import 'bootstrap/dist/css/bootstrap.css'
import "@kenshooui/react-multi-select/dist/style.css"
import "react-datepicker/dist/react-datepicker.css";
import '../styles/custom.css'
import 'react-pivottable/pivottable.css';

// import '../styles/datatables/dataTables.dataTables.min.css'

import PublicTheme from '../components/layouts/PublicTheme'
import AppTheme from '../components/layouts/AppTheme'
import AdminTheme from '../components/layouts/AdminTheme'
import React, { useState, useEffect, createContext } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import { doGetSession, doLogout } from '../utilities'

function exportableTables() {
    if (typeof window !== 'undefined') {
        // let tables = window.document.getElementsByTagName("table")
        // eliminate tables with class 'no-export'
        let tables = window.document.querySelectorAll("table:not(.no-export)")
        for (let i = 0; i < tables.length; i++) {
            let table = tables[i]
            let tableId = table.id || `table-${i}`
            let button = document.createElement("button")
            button.className = "btn btn-link btn-sm m-1 "
            button.innerHTML = "Export to CSV"
            button.onclick = function () {
                let csv = []
                let rows = table.getElementsByTagName("tr")
                for (let i = 0; i < rows.length; i++) {
                    let row = [], cols = rows[i].querySelectorAll("td, th")
                    let leng_th = cols.length;
                    for (let j = 0; j < leng_th; j++) {
                        // skip 'Actions' column
                        if (cols[j].innerText?.toLowerCase().trim() === 'actions') {
                            leng_th = leng_th - 1;
                            continue;
                        } else {
                            if (j < leng_th - 1) {
                                // escape commas to avoid creating multiple columns
                                row.push(`"${cols[j].innerText.replace(/,/g, ' ')}"`)
                            } else {
                                continue;
                            }
                        }
                    }
                    csv.push(row.join(","))
                }
                let csvFile = new Blob([csv.join("\n")], { type: "text/csv" })
                let downloadLink = document.createElement("a")
                downloadLink.download = tableId + ".csv"
                downloadLink.href = window.URL.createObjectURL(csvFile)
                downloadLink.style.display = "none"
                document.body.appendChild(downloadLink)
                downloadLink.click()
            }
            table.parentNode.insertBefore(button, table)

        }
    }
}

// run exportableTables() function on page load and on DOM mutation
if (typeof window !== 'undefined') {
    let added = false
    // add event listener for DOM mutation (after last mutation)
    let timeout = false
    window.addEventListener("DOMSubtreeModified", function () {
        if (added) return
        added = true
        if (timeout) clearTimeout(timeout)
        timeout = setTimeout(exportableTables, 1000)
    }, false)

    // run exportableTables() function on page load
    window.addEventListener("load", exportableTables, false)

}

function MyApp({ Component, pageProps }) {
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [user, setUser] = useState(null)
    const [session, setSession] = useState(null)
    const [loading, setLoading] = useState(true)
    const [userType, setUserType] = useState(null)

    // auth context
    const AuthContext = createContext({
        isLoggedIn: false,
        user: null,
        session: null,
        setIsLoggedIn: (isLoggedIn) => setIsLoggedIn(isLoggedIn),
        setUser: (user) => setUser(user),
        setSession: (session) => setSession(session),
    })

    const public_pages = ['calendar', 'about', 'scopes', 'auth', 'certification', 'learning-centre', 'help'];

    useEffect(() => {
        let mtd = true
        if (mtd) {
            // import("bootstrap/dist/js/bootstrap.bundle.min");
            doGetSession().then((session) => {
                if (session && (session.isLoggedIn === true || session.isLoggedIn === 'true')) {
                    setUserType(session?.user?.type.trim().toLowerCase().split(' ').join('_'))
                    // if(session.user?.type == 'admin' || session.user?.type == 'super_admin' || session.user?.type == 'superadmin'){
                    //     Layout = AdminTheme
                    // }else{
                    //     Layout = AppTheme
                    // }
                    setIsLoggedIn((session.isLoggedIn === true || session.isLoggedIn === "true"))
                    setUser(session.user)
                    setSession(session)
                    pageProps.session = session
                } else {
                    // Layout = PublicTheme
                    if (typeof window != 'undefined'
                        && !window.location.pathname.includes('/auth')
                        && !window.location.pathname.includes('/calendar')
                        && !window.location.pathname.includes('/about')
                        && !window.location.pathname.includes('/scopes')
                        && !window.location.pathname.includes('/certification')
                        && !window.location.pathname.includes('/learning-centre')
                        && !window.location.pathname.includes('/help/')
                    ) {
                        // window.location.href = '/auth/login'
                        // window.location.reload()
                        doLogout().then(e => {
                            // console.log('session:', e)
                            // console.clear()
                        })
                    }
                    setIsLoggedIn(false)
                    setUser(null)
                    setSession(null)
                    pageProps.session = null
                }
            }).then(() => {
                // Layout = isLoggedIn ? ((user && user?.type == "admin") ? AdminTheme : AppTheme) : PublicTheme
                setLoading(false)
            })
        }
        return () => {
            mtd = false
        }
    }, [])

    return (
        <>
            <Head>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            </Head>
            {/* <Script src="/js/jquery-2.2.4.min.js" /> */}
            <Script src="/js/bootstrap.bundle.min.js" />
            {/* <Script src="/js/datatables/dataTables.js" /> */}
            {/* <Script src="/js/datatables/dataTables.bootstrap5.js" /> */}
            {/* <Script src="/js/datatables/init.js" /> */}

            {loading ? <div style={{ width: '100%', height: '85vh', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className='d-flex flex-column gap-2 align-items-center justify-content-center'>
                    <h5 className='mb-0 text-muted' style={{ marginLeft: '20px' }}>Loading...</h5>
                    <div className="spinner-border spinner-border-xl" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div> : (isLoggedIn && isLoggedIn === true ? (
                userType === 'admin' || userType === 'scope_manager' ? <AdminTheme user_session={session} userType={userType}><Component {...pageProps} /></AdminTheme> : <AppTheme user_session={session} userType={userType}><Component {...pageProps} /></AppTheme>
            ) : (<PublicTheme user_session={session}>
                <Component {...pageProps} />
            </PublicTheme>))}
        </>
    )
}

export default MyApp